module.exports = "./img/40756094d72b70f93747eb626609bbc4.jpg";